import { render } from "./Transparencia.vue?vue&type=template&id=22e5b201"
import script from "./Transparencia.vue?vue&type=script&lang=js"
export * from "./Transparencia.vue?vue&type=script&lang=js"
script.render = render

export default script